if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (activeMedia.nodeName === 'IMG' && activeMedia.naturalWidth && activeMedia.naturalHeight) {
          const maxWidth = window.innerWidth * 0.95;
          const maxHeight = Math.max(160, window.innerHeight * 0.9 - 48);
          const fitRatio = Math.min(maxWidth / activeMedia.naturalWidth, maxHeight / activeMedia.naturalHeight, 1);
          activeMedia.style.width = `${Math.round(activeMedia.naturalWidth * fitRatio)}px`;
          activeMedia.style.height = `${Math.round(activeMedia.naturalHeight * fitRatio)}px`;
          activeMedia.style.objectFit = 'contain';
        }

        activeMedia.scrollIntoView({ block: 'center', inline: 'center' });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
